export default __webpack_public_path__ + "static/candle_box1-97c053619321d2a8fb4e9e5513d74d54.svg";